import React, { Component } from 'react'

import { OuterWrap, Wrap, Background, ContentContainer, Content, TitleContainer, Title } from './styles'

class Hero extends Component {
  render() {
    const { text, title, small, medium, large, retina } = this.props
    const srcset = `${small} 750w, ${medium} 1440w, ${large} 1920w, ${retina} 2560w`

    return (
      <OuterWrap>
        <Wrap setsize={this.props.setsize} title={text}>
          <Background src={large} srcSet={srcset} sizes="(max-width: 1920xp) 100vw, 1920px" />

          {text ? (
            <ContentContainer>
              <Content>{text}</Content>
            </ContentContainer>
          ) : null}
        </Wrap>

        {title ? (
          <TitleContainer title={text}>
            <Title>{title}</Title>
          </TitleContainer>
        ) : null}
      </OuterWrap>
    )
  }
}

export default Hero



// WEBPACK FOOTER //
// ./src/components/Hero/index.js